/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedWordpressArticlesWrapper_editorial = {
    readonly articles: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"EditorialModuleArticles_articles">;
    }> | null;
    readonly totalResults: number | null;
    readonly " $refType": "SbSharedWordpressArticlesWrapper_editorial";
};
export type SbSharedWordpressArticlesWrapper_editorial$data = SbSharedWordpressArticlesWrapper_editorial;
export type SbSharedWordpressArticlesWrapper_editorial$key = {
    readonly " $data"?: SbSharedWordpressArticlesWrapper_editorial$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedWordpressArticlesWrapper_editorial">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedWordpressArticlesWrapper_editorial",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WordpressArticleType",
      "kind": "LinkedField",
      "name": "articles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditorialModuleArticles_articles"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    }
  ],
  "type": "WordpressArticlesType",
  "abstractKey": null
};
(node as any).hash = 'b0b5997b84145ef8d625a0f5c5ce1107';
export default node;
